module.exports = __webpack_public_path__ + "static/about-insta-10@2x-8e977605e23a4031c7534931efc986dd.jpg";